import { useEffect, useRef } from 'react';
import { useAuth } from '@/auth';
import { startTracking } from './tracker';

type Router = Parameters<typeof startTracking>[0];

/** Counts visits on public sites and spaces (never on the platform console). */
export function VisitTracker({ router, enabled }: { router: Router; enabled: boolean }) {
  const { status } = useAuth();
  const signedIn = useRef(false);
  useEffect(() => {
    signedIn.current = status === 'authenticated';
  }, [status]);
  useEffect(() => {
    if (!enabled || import.meta.env.MODE === 'test') return;
    return startTracking(router, () => signedIn.current);
  }, [router, enabled]);
  return null;
}
